// extracted by mini-css-extract-plugin
export default {"introText":"IntroText_introText__uKUOE","textWrap":"IntroText_textWrap__Qn2mj","regular":"IntroText_regular__HQbWA","bold":"IntroText_bold__At3Dy"};